<template>
  <v-dialog
    v-model="dialog"
    width="800"
  >
    <v-card
    class="mx-auto mt-3"
    >
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="entidadesTecnicas"
          item-key="name"
          class="elevation-1"
          :search="search"
          :loading="loading"
        >
          <template v-slot:top>
            <v-row
              class="pa-4"
            >
              <v-col
                class="py-0 my-0"
              />
              <v-col
                class="py-0 my-0"
              >
                <v-text-field
                  v-model="search"
                  label="Buscar en entidad tecnica..."
                  outlined
                />
              </v-col>
            </v-row>
          </template>

          <template v-slot:[`item.cantidad_de_modulos`]="{ item }">
            <template>
            <v-text-field
              v-model="item.cantidad_de_modulos"
              class="mt-8"
              outlined
              @change="changeNumeroDeModulos(item.cantidad_de_modulos,item)"
            ></v-text-field>
            </template>
          </template>

          <template v-slot:[`item.accions`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  depressed
                  color="primary"
                  @click="addEntidadTecnica(item)"
                >
                <v-icon
                  small
                    class="mx-auto"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-plus
                </v-icon>
                  add
                </v-btn>
              </template>
              <span>Agregar</span>
            </v-tooltip>
          </template>

        </v-data-table>
        </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  // import firebase from 'firebase'

  // const db = firebase.firestore()

  export default {
    props: {
      convocatoria: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {
        dialog: false,
        loading: false,
        nombre: '',
        cantidadDeModulos: '',
        estadosConvocatoria: [],
        estadosConvocatoriaSelected: '',
        dialogWaitGps: false,
        Latitude: 0,
        Longitude: 0,
        zoomMap: 13,
        search: '',
        headers: [
          { text: 'Razon Social', value: 'razon_social' },
          { text: 'Número de modulos', value: 'cantidad_de_modulos' },
          { text: 'Zona', value: 'zona' },
          { text: 'Accions', value: 'accions' },

        ],
        entidadesTecnicas: [],
        numeroDeModulos: [],
      }
    },
    computed: {
      isAdmin () {
        return JSON.parse(localStorage.userAuth).perfil === 'Administrador'
      }
    },
    mounted () {
      this.estadosConvocatoria = this.$store.state.estadosConvocatorias
    },
    methods: {
      open (item) {
        this.dialog = true
        this.getEntidadesTecnicas()
      },
      close () {
        this.dialog = false
        this.loading = false
      },
      async getEntidadesTecnicas () {
        this.entidadesTecnicas = []

        const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/entidadSinNegociacion/' + this.convocatoria.id)
        const entidades = await response.json()

        if (entidades.success) {
          this.entidadesTecnicas = entidades.data
        } else {
        }
      },
      async addEntidadTecnica (item) {
        this.loading = true

        const payload = {
          id_convocatoria: this.convocatoria.id,
          id_entidadTecnica: item.id,
          cantidad_de_modulos: parseInt(this.numeroDeModulos)
        }
        const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/add/entidad', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        })

        const data = await response.json()
        if (data.success) {}

        if (data.success) {
          this.close()
          this.loading = false
          this.$emit('onAgregarEntidadTecnica')
        } else {
        
          // this.loading = false
          // this.$toast.open({
          //   message: data.message,
          //   type: 'error',
          //   position: 'top-right',
          //   duration: 5000
          // })
        }
      },
      changeNumeroDeModulos (numeroDeModulos, item) {
        this.numeroDeModulos = numeroDeModulos
      }
    }
  }
</script>
